import { useCallback } from "react";

import renderApplyStakeChecking from "../Organisms/Modals/Stake Checking/apply-stake-checking";
import renderStakeCheckingApproved from "../Organisms/Modals/Stake Checking Status/stake-checking-approved";
import renderStakeCheckingDenied from "../Organisms/Modals/Stake Checking Status/stake-checking-denied";
import renderStakeCheckingPending from "../Organisms/Modals/Stake Checking Status/stake-checking-pending";
import renderStakeCheckingReview from "../Organisms/Modals/Stake Checking Status/stake-checking-review";
import renderStakeCheckingVerificationPending from "../Organisms/Modals/Stake Checking Status/stake-checking-verification-pending";
import renderStakeCheckingClosedForNonCompliance from "../Organisms/Modals/Stake Checking/stake-checking-closed-for-non-compliance";

import { useModalContext } from "../Contexts/ModalContext";

import {
  isSVDApproved,
  isSVDClosedForStakeSaverNonCompliance,
  isSVDDenied,
  isSVDEligible,
  isSVDPending,
  isSVDPendingVerification,
  isSVDReview,
} from "../Utils/helpers";

export default function useStakeCheckingStatusAction() {
  const modalContext = useModalContext();

  const stakeCheckingStatusAction = useCallback(
    (data) => {
      if (isSVDEligible(data)) {
        renderApplyStakeChecking(modalContext);
      } else if (isSVDApproved(data)) {
        renderStakeCheckingApproved(modalContext);
      } else if (isSVDDenied(data)) {
        renderStakeCheckingDenied(modalContext);
      } else if (isSVDPending(data)) {
        renderStakeCheckingPending(modalContext);
      } else if (isSVDReview(data)) {
        renderStakeCheckingReview(modalContext);
      } else if (isSVDPendingVerification(data)) {
        renderStakeCheckingVerificationPending(modalContext);
      } else if (isSVDClosedForStakeSaverNonCompliance(data)) {
        renderStakeCheckingClosedForNonCompliance(modalContext);
      }
    },
    [modalContext],
  );

  return stakeCheckingStatusAction;
}
